export const TRANSLATION_SCOPE = 'questionnaireEditorModule';
export const TRANSLATION_EDITOR_SCOPE = [TRANSLATION_SCOPE, 'editor'];
